import { render, staticRenderFns } from "./SettingsDeliveryAndPaymentsSection.vue?vue&type=template&id=7adbb956&"
import script from "./SettingsDeliveryAndPaymentsSection.vue?vue&type=script&lang=js&"
export * from "./SettingsDeliveryAndPaymentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports